/**
 * Created by mac on 12/23/20
 */

const ResourceCollectibleView = function (component, unitView) {
    this.unitView = unitView;
};

ResourceCollectibleView.prototype.collectionAnimation = function (index, target, duration) {
    const map = Map2d.currentMap;
    const mapView = map.getMapView();
    const targetPosition = mapView.alignInGrid(target.x, target.y);

    Map2d.currentMap.focusOnTarget(cleverapps.clone(targetPosition), {
        skipFocusReport: true,
        duration
    });

    const movingNode = cleverapps.Scenes.GetMovingNode(this.unitView);

    this.unitView.replaceParentSamePlace(movingNode, {
        keepScale: true
    });

    const distance = cc.pSub(targetPosition, this.unitView);

    this.unitView.runAction(new cc.Sequence(
        new cc.JumpAnimation(duration, this.unitView, distance, cleverapps.styles.UnitView.spawnHeight),
        new cc.RemoveSelf()
    ));
};